export default __webpack_public_path__ + "static/media/thunder_icon128.c7947b64.png";